<div class="loader-dot-pulse loader-dot-pulse--primary loader-dot-pulse--size-{{ size }}">
    <div class="loader-dot-pulse__dot"></div>
    <div class="loader-dot-pulse__dot"></div>
    <div class="loader-dot-pulse__dot"></div>
</div>
